// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapObjectWithOrder = <Input, Result, Key extends keyof any>(
  object: Record<Key, Input>,
  order: Key[],
  cb: (value: Input, index: number) => Result
): Result[] => order.map((value, index) => cb(object[value], index));
